import TypeContainer from './TypeContainer';
export default TypeContainer;
